import { render, staticRenderFns } from "./chooseAddress.vue?vue&type=template&id=3589c8ea"
import script from "./chooseAddress.vue?vue&type=script&lang=js"
export * from "./chooseAddress.vue?vue&type=script&lang=js"
import style0 from "./chooseAddress.vue?vue&type=style&index=0&id=3589c8ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports